
// --------------------------------
// Copyright (c) 2023 Eco8 S.r.l.
// --------------------------------
import { Ionicons,FontAwesome } from "@expo/vector-icons";
import colors from "../config/colors";
import styles from "../styles/Carrier/TransportCardStyle";

import {
  View,
  Text,
  Image,
} from "react-native";
export const validateSubstance = (substance) => {
  if (substance) {
    const sanitizedText = substance.replace(/[^0-9]/g, "").substring(0, 3);
    const formattedValue = `${
      sanitizedText.slice(0, 1) || "0"
    }.${sanitizedText.slice(1, 3).padEnd(2, "0")}`;
    return formattedValue;
  }
  return;
};

export const getContainerBackgroundColor = (status) => {
    switch (status) {
    case "Completed":
      return colors.greenWater;
    case "Done":
      return colors.greenWater;
    case "OnGoing":
      return colors.lightViolet;
    case "Warning":
      return colors.magenta;
    default:
      return colors.white;
  }
};

export const getDividerColor = (status) => {
  switch (status) {
    case "Completed":
      return colors.white;
    case "Done":
      return colors.white;
    case "OnGoing":
      return colors.violet;
    case "Warning":
      return colors.white;
    default:
      return colors.green;
  }
};

export const getTitleColor = (status) => {
  switch (status) {
    case "Completed":
          return colors.white;
    case "Done":
        return colors.white;
    case "OnGoing":
      return colors.violet;
    case "Warning":
      return colors.white;
    default:
      return colors.green;
  }
};

export const getFarmerImage = (status) => {
    switch (status) {
      case "Completed":
        return require("../images/Transportatore/contadinoWhite.png");
      case "Done":
        return require("../images/Transportatore/contadinoWhite.png");
      case "OnGoing":
        return require("../images/Transportatore/contadinoPurple.png");
      case "Warning":
        return require("../images/Transportatore/contadinoWhite.png");
      default:
        return require("../images/Transportatore/contadinoGreen.png");
    }
  };

  export const getDepositImage = (status) => {
    switch (status) {
      case "Completed":
        return require("../images/Transportatore/stoccaggio-bianco.png");
      case "Done":
        return require("../images/Transportatore/stoccaggio-bianco.png");
      case "OnGoing":
        return require("../images/Transportatore/stoccaggio-viola.png");
      case "Warning":
        return require("../images/Transportatore/stoccaggio-bianco.png");
      default:
        return require("../images/Transportatore/stoccaggio-verde.png");
    }
  };

  export const getStatusIconMinus = (status) => {
    switch (status) {
      case "Completed":
        return <Ionicons name="ios-remove" size={30} color={colors.white} />;
      case "Done":
        return <Ionicons name="ios-remove" size={30} color={colors.white} />;
      case "OnGoing":
        return <Ionicons name="ios-remove" size={30} color={colors.violet} />;
      case "Warning":
        return <Ionicons name="ios-remove" size={30} color={colors.white} />;
      default:
        return <Ionicons name="ios-remove" size={30} color={colors.green} />;
    }
  };

  export const getStatusIconPlus = (status) => {
      switch (status) {
    case "Completed":
        return <Ionicons name="ios-add" size={30} color={colors.white} />;
      case "Done":
        return <Ionicons name="ios-add" size={30} color={colors.white} />;
      case "OnGoing":
        return <Ionicons name="ios-add" size={30} color={colors.violet} />;
      case "Warning":
        return <Ionicons name="ios-add" size={30} color={colors.white} />;
      default:
        return <Ionicons name="ios-add" size={30} color={colors.green} />;
    }
  };

  export const getPlantImage = (status) => {
    switch (status) {
      case "Completed":
            return require("../images/Transportatore/impiantoWhite.png");
    case "Done":
        return require("../images/Transportatore/impiantoWhite.png");
      case "OnGoing":
        return require("../images/Transportatore/impiantoPurple.png");
      case "Warning":
        return require("../images/Transportatore/impiantoWhite.png");
      default:
        return require("../images/Transportatore/impiantoGreen.png");
    }
  };

  export const getFromIcon = (status, ownerFromType) => {
    switch (ownerFromType) {
      case 1:
        return getPlantImage(status);
      case 2:
        return getFarmerImage(status);
      case 3:
        return getDepositImage(status);
      default:
        return null;
    }
  };

  export const getToIcon = (status, ownerTypeTo) => {
    switch (ownerTypeTo) {
      case 1:
        return getPlantImage(status);
      case 2:
        return getFarmerImage(status);
      case 3:
        return getDepositImage(status);
      default:
        return null;
    }
};

export const isCompleted = (status) => {
    return status === "Completed" || status === "Done";
};

  export const renderPlannedDate = (plannedDate,status) => {
    const plannedDateStyle = {
      ...styles.plannedDateText,
      color: getTitleColor(status),
    };
    return (
      <View style={styles.plannedDateContainer}>
        <Text style={plannedDateStyle}>{plannedDate}</Text>
      </View>
    );
  };

  export const renderRoute = (status,addressFrom,addressTo,ownerFromType,ownerTypeTo) => {
    return (
      <View style={styles.routeContainer}>
        <View style={styles.textContainer}>
          <Image
            source={getFromIcon(status, ownerFromType)}
            style={styles.image}
          />
          <Text style={[styles.title, { color: getTitleColor(status) }]}>
            {addressFrom.ownerName}
          </Text>
        </View>
        <View style={styles.arrowContainer}>
          <Text style={styles.icon}>
            {isCompleted(status) ? (
              <Image
                source={require("../images/Transportatore/consegnato.png")}
                style={{ width: 59, height: 51 }}
              />
            ) : status === "OnGoing" ? (
              <Image
                source={require("../images/Transportatore/delivery.png")}
                style={{ width: 59, height: 51 }}
              />
            ) : status === "Warning" ? (
              <FontAwesome
                name="exclamation-triangle"
                size={40}
                color={colors.white}
                style={{ marginBottom: 8 }}
              />
            ) : (
              <Image
                source={require("../images/Transportatore/freccia.png")}
                style={{ width: 59, height: 51 }}
              />
            )}
          </Text>
        </View>
        <View style={styles.textContainer}>
          <Image source={getToIcon(status, ownerTypeTo)} style={styles.image} />
          <Text style={[styles.title, { color: getTitleColor(status) }]}>
            {addressTo.ownerName}
          </Text>
        </View>
      </View>
    );
  };

  const logger = require("../axios/loggingConfig");

